import { CoverageAssistantFilters } from '@procureai/ui-modules-mui';

import { PersistedJsonSerde } from '~/hooks/usePersistedJson/usePersistedJson';

interface PersistedCoverageAssistantFilters {
  timeframe: [string, string];
  commodityGroups: string[];
  organizations: string[];
  commodities: string[];
}

const isStringArray = (value: unknown): value is string[] =>
  Array.isArray(value) && value.every((item) => typeof item === 'string');

const parseDate = (value: unknown): Date | null => {
  if (typeof value !== 'string') return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const serializeCoverageAssistantFilters = (
  filters: CoverageAssistantFilters,
): PersistedCoverageAssistantFilters => ({
  timeframe: [filters.timeframe[0].toISOString(), filters.timeframe[1].toISOString()],
  commodityGroups: filters.commodityGroups,
  organizations: filters.organizations,
  commodities: filters.commodities,
});

export const deserializeCoverageAssistantFilters = (raw: unknown): CoverageAssistantFilters | undefined => {
  if (!raw || typeof raw !== 'object') return undefined;
  const candidate = raw as Partial<PersistedCoverageAssistantFilters>;
  const timeframe = candidate.timeframe;
  if (!Array.isArray(timeframe) || timeframe.length !== 2) return undefined;
  const from = parseDate(timeframe[0]);
  const to = parseDate(timeframe[1]);
  if (!from || !to) return undefined;
  if (!isStringArray(candidate.commodityGroups)) return undefined;
  if (!isStringArray(candidate.organizations)) return undefined;
  if (!isStringArray(candidate.commodities)) return undefined;
  return {
    timeframe: [from, to],
    commodityGroups: candidate.commodityGroups,
    organizations: candidate.organizations,
    commodities: candidate.commodities,
  };
};

export const coverageAssistantFiltersSerde: PersistedJsonSerde<CoverageAssistantFilters> = {
  serialize: serializeCoverageAssistantFilters,
  deserialize: deserializeCoverageAssistantFilters,
};
